var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("Autocomplete", {
        attrs: {
          placeholder: _vm.placeholder,
          currentUserId: _vm.currentUserId,
        },
        on: { select: _vm.handleSelection, clear: _vm.handleClear },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }